import { type GridApi } from '@ag-grid-community/core';

/**
 * Deselects all rows in all detail grids (nested grids) without affecting the main grid
 * @param api - The AG Grid API instance
 */
export function deselectAllDetailGrids<T = any>(api: GridApi<T>): void {
    api.forEachDetailGridInfo((detailGrid) => {
        detailGrid.api?.deselectAll();
    });
}

/**
 * Deselects all rows in the main grid and all detail grids (nested grids)
 * @param api - The AG Grid API instance
 */
export function deselectAllIncludingDetails<T = any>(api: GridApi<T>): void {
    api.deselectAll();
    deselectAllDetailGrids(api);
}
